import {SelectItem} from '../components/select-input/select-item';

export enum UserRole {
    ADMIN        = 'ADMIN',
    TRADER       = 'TRADER',
    TRADER_ADMIN = 'TRADER_ADMIN'
}

export const USER_ROLE_NAMING: Record<UserRole, string> = {
    [UserRole.ADMIN]:        'enums.user-role.admin',
    [UserRole.TRADER]:       'enums.user-role.trader',
    [UserRole.TRADER_ADMIN]: 'enums.user-role.trader_admin'
};

export const USER_ROLE_SELECT_ITEMS: Array<SelectItem<UserRole>> = [
    UserRole.ADMIN,
    UserRole.TRADER,
    UserRole.TRADER_ADMIN
].map(value => ({
    value,
    label: USER_ROLE_NAMING[value]
}));
